
































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { memberGroupList } from '@/utils/project';
import { queryDlDmUser, applyPermission, stateList, ifApplyPermission } from '@/api/project';

const stateMap = {
  21: 'patentOffice',
  8: 'exited',
  17: 'cleared',
  16: 'occupation'
};

@Component({
  components: {}
})
class AuthApply extends Vue {
  type: number = 1;
  options: any[] = [];
  memberGroupList: any[] = memberGroupList;
  reason: string = '';
  userValue: number = 2;
  dl: string = '';
  dm: string = '';
  validityVal: number = 7;
  stateList: any[] = [];
  isApplying: boolean = false;
  loading: boolean = false;
  pageLoading: boolean = true;

  mounted() {
    this.getifApplyPermission();
  }

  async getifApplyPermission() {
    try {
      let res = await ifApplyPermission({
        type: 1,
        companyId: this.$route.query.id
      });
      this.pageLoading = false;
      if (res.code === 200) {
        if (res.data) {
          this.isApplying = true;
        } else {
          this.options = memberGroupList
            .map(_ => {
              return {
                label: _.name,
                value: _.id
              };
            })
            .filter(_ => {
              return _.value !== 1;
            });
          this.getDlDm();
          this.getStateList();
        }
      }
    } catch (err) {
      this.pageLoading = false;
      console.log(err);
    }
  }

  async getStateList() {
    try {
      let res = await stateList();
      if (res.code === 200) {
        this.stateList = res.data
          .map(_ => {
            return {
              ..._,
              checked: _.ifAuth === 1
            };
          })
          .filter(_ => {
            return !stateMap[_.id];
          });
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getDlDm() {
    try {
      let res = await queryDlDmUser({ id: this.$route.query.id });
      if (res.code === 200) {
        this.dl = res.data.dls[0].nickname;
        this.dm = res.data.dms.map(_ => _.nickname).join('、');
      }
    } catch (err) {
      console.log(err);
    }
  }

  onChange(e) {
    this.type = e.target.value;
  }

  checkChange(obj) {
    let index = this.stateList.findIndex(_ => _.id === obj.id);
    this.$set(this.stateList, index, { ...obj, checked: !obj.checked });
  }

  userChange(e) {
    this.userValue = e.target.value;
  }

  validityChange(e) {
    this.validityVal = e.target.value;
  }

  async apply() {
    try {
      if (this.reason) {
        let data = {
          type: 1,
          companyId: this.type === 1 ? this.$route.query.id : '',
          reason: this.reason
        };
        if (this.type === 2) {
          let stateIds = this.stateList
            .filter(_ => {
              return _.ifAuth === -1 && _.checked;
            })
            .map(_ => _.id)
            .join(',');
          if (!stateIds) {
            this.$message.error('阶段不能为空');
            return;
          } else {
            data['stateIds'] = stateIds;
          }
        } else {
          data['userType'] = this.userValue;
          if (this.userValue === 9) {
            data['validityDay'] = this.validityVal ? this.validityVal : '';
          }
        }
        this.loading = true;
        let res = await applyPermission(data);
        this.loading = false;
        if (res.code === 200) {
          this.$message.success('申请成功');
          this.reason = '';
          this.getifApplyPermission();
        }
      } else {
        this.$message.error('申请理由不能为空');
      }
    } catch (err) {
      this.loading = false;

      console.log(err);
    }
  }
}

export default AuthApply;
